import { HOURS, PHONE_DISPLAY } from "../data/menu";
import { LogoMark } from "./Logo";
import { scrollToId } from "../lib/scroll";

export const Footer = () => (
  <footer className="bg-[#3D2314] text-[#FAF4EC]" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 grid gap-10 md:grid-cols-3">
      <div>
        <div className="flex items-center gap-3">
          <LogoMark size={44} />
          <div className="leading-none">
            <span className="font-display font-bold text-xl block">Harshi&rsquo;s</span>
            <span className="block text-[0.6rem] font-semibold tracking-[0.32em] text-[#D86A7A] uppercase mt-1">Kitchen</span>
          </div>
        </div>
        <p className="text-sm text-[#C4B3A4] mt-4 max-w-xs leading-relaxed">
          Taste, Tradition and Celebration with Love. Homemade • Fresh • Delicious.
        </p>
      </div>
      <div>
        <h3 className="text-xs font-bold tracking-[0.25em] uppercase text-[#D86A7A] mb-4">Explore</h3>
        <ul className="space-y-2.5 text-sm">
          {[
            { id: "home", label: "Home" },
            { id: "menu", label: "Menu / Order Food" },
            { id: "contact", label: "Contact" },
          ].map((l) => (
            <li key={l.id}>
              <button onClick={() => scrollToId(l.id)} className="text-[#C4B3A4] hover:text-[#FFFDF8] transition-colors">
                {l.label}
              </button>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <h3 className="text-xs font-bold tracking-[0.25em] uppercase text-[#D86A7A] mb-4">Order Hours</h3>
        <p className="text-sm text-[#C4B3A4]">{HOURS}</p>
        <p className="text-sm text-[#C4B3A4] mt-1.5">Call / WhatsApp: {PHONE_DISPLAY}</p>
        <p className="text-xs text-[#8A7364] mt-5 italic">No return once delivered. Freshly cooked on order.</p>
      </div>
    </div>
    <div className="border-t border-[#5A4232]/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-[#8A7364]">
        <span>© 2025 Harshi&rsquo;s Kitchen. All rights reserved.</span>
        <span className="font-hand text-base text-[#D86A7A]">Made with love, served with care</span>
      </div>
    </div>
  </footer>
);
